module.exports = __webpack_public_path__ + "static/media/subjects_icon.9cb93c0c.svg";